<div fxLayout>
  <sbnb-confetti #confetti></sbnb-confetti>
  <main [ngClass.lt-md]="{ mobile: true }">
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs></sbnb-page-header>
    </app-feature-flag-tabs>
    <div *ngIf="!loading && (onboardingItems$ | async) as onboardingItems" class="onboarding-container">
      <header>
        <div style="position: relative; height: 152px">
          <img
            *ngIf="onboardingItems.meta.pending_count > 0"
            src="/assets/images/onboarding/badge-incomplete.svg"
            alt="Hospitable badge incomplete" />
          <img
            class="onboarding-badge-complete"
            *ngIf="onboardingItems.meta.pending_count === 0"
            src="/assets/images/onboarding/hospitable-badge.gif"
            alt="Hospitable badge" />
          <span *ngIf="onboardingItems.meta.pending_count" class="onboarding-incomplete-count">
            {{ onboardingItems.meta.pending_count }}
          </span>
        </div>
        <h1 *ngIf="onboardingItems.meta.pending_count === onboardingItems.meta.count">
          Get started in {{ onboardingItems.meta.pending_count }} simple steps.
        </h1>
        <h1
          *ngIf="
            onboardingItems.meta.pending_count !== onboardingItems.meta.count &&
            onboardingItems.meta.pending_count !== 0
          ">
          Only {{ onboardingItems.meta.pending_count }} steps remaining.
        </h1>
        <h1 *ngIf="onboardingItems.meta.pending_count === 0">You have earned the Hospitable badge!</h1>

        <span *ngIf="onboardingItems.meta.pending_count > 0">
          Get onboard with the essentials of
          {{ 'CORE.PRODUCT_NAME' | transloco }} by completing the items below.
        </span>

        <span *ngIf="onboardingItems.meta.pending_count === 0">
          You have completed all onboarding items to earn your Hospitable badge.
        </span>
      </header>

      <div class="onboarding-items">
        <sbnb-onboarding-item *ngFor="let item of onboardingItems.data" [item]="item"></sbnb-onboarding-item>
      </div>
    </div>
  </main>
</div>
